import { useState, useEffect } from 'react';
import Api from '../Services/Api';

/**
 * Hook to fetch Facebook accounts from backend configuration
 * This is the single source of truth for Facebook accounts
 * 
 * @param {string} feature - Optional: 'launcher', 'analytics', or 'all'
 * @returns {object} { accounts, loading, error }
 */
const useFacebookAccounts = (feature = 'all') => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await Api.getFacebookAccounts(feature);
        
        if (response.data && response.data.success) {
          setAccounts(response.data.accounts || []);
        } else {
          setError('Failed to fetch Facebook accounts');
        }
      } catch (err) {
        console.error('Error fetching Facebook accounts:', err);
        setError(err.message || 'Failed to fetch Facebook accounts');
      } finally {
        setLoading(false);
      }
    };

    fetchAccounts();
  }, [feature]);

  return { accounts, loading, error };
};

export default useFacebookAccounts;